import { render, staticRenderFns } from "./no_children_living_at_home.vue?vue&type=template&id=22a669bc"
import script from "./no_children_living_at_home.vue?vue&type=script&lang=js"
export * from "./no_children_living_at_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports